import React from 'react';

function QuestionsAnswersT() {
  return <div></div>;
}

export default QuestionsAnswersT;
